// src/plugins/vuetify.js

import { createVuetify } from 'vuetify';
import 'vuetify/styles'; // Ensure you are using css-loader

export default createVuetify({
  // You can add custom settings here
});
